import React from 'react';
import { Route } from 'react-router-dom';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { RoutePathProps } from '../../../../AppRoutes/types';
import UserList from '../pages/UserList';
// import EditProduct from '../pages/EditProduct';

const user: RoutePathProps = {
    name: "users",
    path: "/users",
    label: "Users",
    icon: PeopleAltIcon,
    visibleInNav: true,
    requiredPermission:'user:list',
    children: [
        // {
        //     name: "role",
        //     path: "/role",
        //     label: "Roles",
        //     icon: AdminPanelSettingsIcon,
        // }
    ],
};

const UserRoutes = (
    <>
        <Route path={user.path} element={<UserList />} />
        {/* <Route path={role.children?.[0].path} element={<RoleList />} /> */}
    </>
);
export const userPaths = [user];
export default UserRoutes;
